import { Component, computed, inject } from '@angular/core';
import { LanguageService } from '../../../services/language/language.service';
import { TranslatePipe } from '../../translation/translate.pipe';
import { RouterLinkDirective } from '../../directives/router-link.directive';
import { Router, RouterLink } from '@angular/router';
import { InstallAppService } from '../../../services/install-app.service';
import { ROOT_LANG } from '../../../helpers/router';
import { Location } from '@angular/common';
import { first } from 'rxjs/operators';
import { TranslationService } from '../../translation/translation.service';
import { EnvironmentService } from '../../../services/environment.service';
import { SeoService } from '../../../services/seo.service';


@Component({
    selector: 'app-bottom-navigation',
    templateUrl: './bottom-navigation.component.html',
    styleUrls: ['./bottom-navigation.component.scss'],
    imports: [RouterLink, RouterLinkDirective, TranslatePipe]
})
export class BottomNavigationComponent {

  env = inject(EnvironmentService);
  lang = inject(LanguageService);
  installApp = inject(InstallAppService);
  seo = inject(SeoService);
  private _location = inject(Location);
  private _router = inject(Router);
  private _translationService = inject(TranslationService);

  public ROOT_LANG = ROOT_LANG;

  public currentPath = computed(() => {
    const fullPath = this._location.path();
    const arrPath = fullPath.split('/');
    const isRootLang = this.lang.current === ROOT_LANG;
    let pathWithoutLang: string;
    if (isRootLang) {
      pathWithoutLang = arrPath.slice(1).join('/');
    } else {
      pathWithoutLang = arrPath.slice(2).join('/');
    }
    if (!pathWithoutLang) {
      return '';
    }
    return pathWithoutLang;
  });

  public changeLanguage(lang: string) {
    let url = '';
    if (lang === ROOT_LANG) {
      url = this._router.url.replace(`/${this.lang.current}`, '');
    } else {
      if (this.lang.current === ROOT_LANG) {
        url = `/${lang}` + this._router.url;
      } else {
        url = this._router.url.replace(`/${this.lang.current}`, `/${lang}`);
      }
    }
    if (url.length > 1 && url.endsWith('/')) {
      url = url.slice(0, -1);
    }
    this.lang.changeLang(lang);
    this._router.navigateByUrl(`/${url}`, { replaceUrl: true })
      .then(() => {
        this._translationService.loadTranslates().pipe(first()).subscribe();
      });
  }



}
